import { CookieStorage, getCookieDomain } from '@crossnokaye/ux-common';

/**
 * Creates a CookieStorage configured for cross-domain cookies shared with
 * other CrossnoKaye apps (e.g. Darkwing). Only `maxAge` varies per caller;
 * the other options must stay aligned for the cookies to round-trip.
 */
export function createCkCookieStorage(maxAge: number): CookieStorage {
  return new CookieStorage({
    domain: getCookieDomain(window.location.hostname),
    maxAge,
    sameSite: 'lax',
    path: '/',
    secure: window.location.protocol === 'https:',
  });
}
